import axios from "axios";
import { API_ELSTIC_URL } from "../../config";

const authH = () => ({
  Authorization: `Bearer ${localStorage.getItem("cms_token")}`,
});

// API 1 — Trademark filings
export const fetchAttorneyFilings = async (userId, page = 1, limit = 50, filters = {}) => {
  const params = { user_id: userId, page, limit, ...filters };
  Object.keys(params).forEach((k) => { if (params[k] === "" || params[k] === undefined || params[k] === null) delete params[k]; });
  const res = await axios.get(`${API_ELSTIC_URL}/cms/user/get-attorney-details`, {
    params,
    headers: authH(),
  });
  return res.data;
};

// API 2 — Inbound oppositions
export const fetchInboundOppositions = async (userId, page = 1, limit = 50, filters = {}) => {
  const params = { user_id: userId, page, limit, ...filters };
  Object.keys(params).forEach((k) => { if (params[k] === "" || params[k] === undefined || params[k] === null) delete params[k]; });
  const res = await axios.get(`${API_ELSTIC_URL}/cms/user/get-attorney-inbound-oppositions`, {
    params,
    headers: authH(),
  });
  return res.data;
};

// API 3 — Outbound oppositions
export const fetchOutboundOppositions = async (userId, page = 1, limit = 50, filters = {}) => {
  const params = { user_id: userId, page, limit, ...filters };
  Object.keys(params).forEach((k) => { if (params[k] === "" || params[k] === undefined || params[k] === null) delete params[k]; });
  const res = await axios.get(`${API_ELSTIC_URL}/cms/user/get-attorney-outbound-opposition`, {
    params,
    headers: authH(),
  });
  return res.data;
};

// API 4 — Dashboard stats
export const fetchDashboardStatus = async (userId) => {
  const res = await axios.get(`${API_ELSTIC_URL}/cms/user/get-attorney-dashboard-status`, {
    params: { user_id: userId },
    headers: authH(),
  });
  return res.data;
};

// API 5 — Portfolio hearings (today)
export const fetchPortfolioHearings = async (userId) => {
  const res = await axios.get(`${API_ELSTIC_URL}/cms/user/portfolio-hearings`, {
    params: { user_id: userId },
    headers: authH(),
  });
  return res.data;
};

// API 6 — All deadlines
export const fetchAllDeadlines = async (userId, filters = {}) => {
  const params = { user_id: userId, limit: 500, ...filters };
  // Remove empty values
  Object.keys(params).forEach((k) => { if (params[k] === "" || params[k] === undefined || params[k] === null) delete params[k]; });
  const res = await axios.get(`${API_ELSTIC_URL}/cms/user/all-deadlines`, {
    params,
    headers: authH(),
  });
  return res.data;
};

// API 7 — Journal match results (pre-matched)
export const fetchJournalResults = async (userId, journalCode, filters = {}) => {
  const params = { user_id: userId, journal_code: journalCode, ...filters };
  Object.keys(params).forEach((k) => { if (params[k] === "" || params[k] === undefined || params[k] === null) delete params[k]; });
  const res = await axios.get(`${API_ELSTIC_URL}/cms/user/get-attorney-journal-results-v2`, {
    params,
    headers: authH(),
  });
  return res.data;
};

// API 8 — Pre-journal live comparison
export const fetchPreJournalData = async (userId, page = 1, limit = 50, filters = {}) => {
  const params = { user_id: userId, page, limit, ...filters };
  Object.keys(params).forEach((k) => { if (params[k] === "" || params[k] === undefined || params[k] === null) delete params[k]; });
  const res = await axios.get(`${API_ELSTIC_URL}/cms/user/get-attorney-pre-journal-data`, {
    params,
    headers: authH(),
  });
  return res.data;
};

// API 9 — Master journal codes (no auth)
export const fetchMasterJournalData = async () => {
  const res = await axios.get(`${API_ELSTIC_URL}/companies/get-master-journal-data`);
  return res.data;
};



// Fetch attorney renewal data
export const fetchAttorneyRenewalData = async ({ userId, page = 1, limit = 50 }) => {
  const response = await axios.get(`${API_ELSTIC_URL}/cms/user/get-attorney-renewal-data`, {
    params: { user_id: userId, page, limit },
    headers: authH(),
  });
  if (response.data.status === 200 || response.data.success) {
    return response.data;
  }
  throw new Error(response.data.message || "Failed to fetch renewal data");
};